import consts from './consts';
import * as PIXI from 'pixi.js';

export default {

    get backgroundConfig() {
        const ctx = consts.assets.general.find(asset => asset.name === 'background');
        if (ctx) return ctx;
    },

    assetUrl(file, inSprites = false) {
        return `${consts.assets.root}${inSprites ? '/' + consts.assets.symbol.root : ''}/${file}`;
    },

    get isMobile() {
        return PIXI.utils.isMobile.any;
    },

    getShortFormat(number = 0, fraction = 2) {
        if (number == 0) return 0
        const notations = ["", "K", "M", "B", "T", "P", "E", "Z", "Y"],
            i = Math.floor(Math.log(number) / Math.log(1000))
        return `${parseFloat((number / Math.pow(1000, i)).toFixed(fraction))}${
            notations[i]
        }`
    },

    getFormattedAmount(amount) {
        return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },

    center(element, { width, height }, { vertically = true, horizontally = true } = {}) {
        /* eslint-disable no-param-reassign */
        element.x = horizontally ? (width / 2) - (element.width / 2) : element.x;
        element.y = vertically ? (height / 2) - (element.height / 2) : element.y;
        /* eslint-enable no-param-reassign */
    },

    getVolumeValueFromLocalStorage(key, fallback = 0.1) {
        const data = window.localStorage.getItem(key);
        const _float = parseFloat(data);

        if (data !== null && _float <= 1 && _float >= 0) return _float;

        window.localStorage.setItem(key, fallback.toString());
        return fallback;
    }

}